import uuid4 from 'uuid/v4';
import gzip from 'gzip-js';
import {AWS_SIGNED_URL} from '../constants';
import RawDataCollection from '../models/raw-data-collection';

const _S3_CACHE = {};


export function gzipJSON(data) {
  data = JSON.stringify(data);
  data = unescape(encodeURIComponent(data)); // encode with utf-8
  data = new Uint8Array(gzip.zip(data, {level: 2}));
  return new Blob([data], {type: 'application/gzip'});
}

export function ungzipJSON(data) {
  data = new Uint8Array(gzip.unzip(data));
  data = new TextDecoder('utf-8').decode(data);
  return JSON.parse(data);
}

async function saveS3(key, data) {
  data = gzipJSON(data);

  const upload_url = await getSignedURL(key, 'save', data.type);

  const resp = await fetch(upload_url, {
      method: 'PUT',
      headers: {
          'Content-Type': data.type,
      },
      body: data
    });

  return key;
}


async function loadS3(key) {
  const upload_url = await getSignedURL(key, 'load');

  const resp = await fetch(upload_url);
  const blob = await resp.arrayBuffer();
  const content = ungzipJSON(new Uint8Array(blob));
  return content;
}


function loadModelClasses(data) {
  if ('rawDataCollection' in data ) {
    data.rawDataCollection = data.rawDataCollection instanceof RawDataCollection?
      data.rawDataCollection : new RawDataCollection(data.rawDataCollection);
  }
  return data;
}


export async function getStorage(key) {
  if (key in _S3_CACHE) {
    return _S3_CACHE[key];
  }

  let data = await loadS3(key);
  data = loadModelClasses(data);
  _S3_CACHE[key] = data;

  return data;
}

function loadCurrentKey(data) {
  let key = data.uuid;
  if ('rawDataCollection' in data) {
    key = data.rawDataCollection.uuid;
  }
  if (!key) {
    key = uuid4();
    data.uuid = key;
  }

  return key;
}


async function getSignedURL(key, operation, content_type=null) {
  const request = new Request(
    AWS_SIGNED_URL,
    {
      method: "POST",
      body: JSON.stringify({
        'key': key,
        'operation': operation,
        'content_type': content_type
      })
    }
  );
  let resp = await fetch(request);
  let json = await resp.json();

  if (!('operation' in json)) {
    console.log('AWS Service error, please contact hivdbteam@stanford.edu');
  }

  const upload_url = json['upload_url'];
  return upload_url;
}


export async function updateStorage(state, prevKey) {
  let data = state;

  if (prevKey) {
    data = await getStorage(prevKey);
    Object.assign(data, state);
  }

  const key = loadCurrentKey(data);

  delete _S3_CACHE[key];
  return await saveS3(key, data);
}


export function getlocal(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function setlocal(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}



// WEBPACK FOOTER //
// ./src/utils/storage.js